/**
 * Pull a readable message out of an ApiError. celebrate/Joi validation errors
 * bury the useful text under `validation.<source>.message`, leaving the
 * top-level message as a generic "Validation failed".
 */
export const apiErrorMessage = (
  err: any,
  fallback = "Something went wrong. Please try again."
): string => {
  const body = err?.data;
  if (!body) return err?.message ?? fallback;

  const validation = body.validation;
  if (validation && typeof validation === "object") {
    const parts = Object.values(validation)
      .map((v: any) => v?.message)
      .filter(Boolean);
    if (parts.length) return parts.join(" · ");
  }

  return body.message ?? body.error ?? err?.message ?? fallback;
};
